module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: [_vm.block, {
      'bm-open': _vm.mobileMenuOpen
    }]
  }, [_c('div', {
    class: [_vm.block + '-hitbox'],
    on: {
      "click": _vm.toggleMobileMenu
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-line m-top']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-line m-middle']
  }), _vm._v(" "), _c('div', {
    class: [_vm.block + '-line m-bottom']
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b421133","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/templates/Hamburger.vue
// module id = 535
// module chunks = 0